import { render, staticRenderFns } from "./ElectiveCourses.vue?vue&type=template&id=45d907e8"
import script from "./ElectiveCourses.vue?vue&type=script&lang=js"
export * from "./ElectiveCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports